import { supabase, supabaseAdmin } from '../lib/supabaseClient';

type RestaurantRow = {
  id: string;
  name: string;
  slug: string;
  city: string;
  district: string;
  accepts_delivery: boolean | null;
  accepts_takeaway: boolean | null;
  is_accepting_orders: boolean | null;
  minimum_order_amount: number | null;
  delivery_radius_km: number | null;
  updated_at: string | null;
};

export interface RestaurantRecord {
  id: string;
  name: string;
  slug: string;
  city: string;
  district: string;
  acceptsDelivery: boolean;
  acceptsTakeaway: boolean;
  isAcceptingOrders: boolean;
  minimumOrderAmount: number | null;
  deliveryRadiusKm: number | null;
  updatedAt: string | null;
}

const mapRestaurant = (row: RestaurantRow): RestaurantRecord => ({
  id: row.id,
  name: row.name,
  slug: row.slug,
  city: row.city,
  district: row.district,
  acceptsDelivery: Boolean(row.accepts_delivery),
  acceptsTakeaway: Boolean(row.accepts_takeaway),
  isAcceptingOrders: Boolean(row.is_accepting_orders),
  minimumOrderAmount:
    row.minimum_order_amount !== null ? Number(row.minimum_order_amount) : null,
  deliveryRadiusKm:
    row.delivery_radius_km !== null ? Number(row.delivery_radius_km) : null,
  updatedAt: row.updated_at ?? null,
});

const RESTAURANT_SELECT = `
  id,
  name,
  slug,
  city,
  district,
  accepts_delivery,
  accepts_takeaway,
  is_accepting_orders,
  minimum_order_amount,
  delivery_radius_km,
  updated_at
`;

export async function listRestaurants(): Promise<RestaurantRecord[]> {
  const client = supabaseAdmin ?? supabase;

  const { data, error } = await client
    .from('restaurants')
    .select(RESTAURANT_SELECT)
    .order('name', { ascending: true });

  if (error) {
    throw error;
  }

  return ((data ?? []) as unknown as RestaurantRow[]).map(mapRestaurant);
}

interface UpdateMinimumInput {
  id: string;
  amount: number | null;
}

export async function updateRestaurantMinimumOrder(
  input: UpdateMinimumInput,
): Promise<RestaurantRecord> {
  const client = supabaseAdmin ?? supabase;

  const { data, error } = await client
    .from('restaurants')
    .update({
      minimum_order_amount: input.amount,
      updated_at: new Date().toISOString(),
    })
    .eq('id', input.id)
    .select(RESTAURANT_SELECT)
    .maybeSingle();

  if (error) {
    throw error;
  }
  if (!data) {
    throw new Error('Restoran ayarı kaydedilemedi. Yetki/RLS nedeniyle kayıt değişmemiş olabilir.');
  }

  return mapRestaurant(data as RestaurantRow);
}
